var map = {
	"./additionalBuy.png": 30504,
	"./address-default.png": 26653,
	"./deposit.png": 46499,
	"./groupon.png": 98948,
	"./inEmployeeGo.png": 96609,
	"./live.png": 36510,
	"./offlineDelivery.png": 19360,
	"./quickBuy.png": 52702,
	"./vipFirst.png": 33921
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46115;